import SubtleBackground from './SubtleBackground';
import { useLocale } from '../i18n/LocaleContext';

const Contact = () => {
    const { t } = useLocale();

    // CONFIGURATION: The Agent's details to display on the card
    const AGENT_DETAILS = {
        name: "Natalia Garcia",
        displayPhone: "+52 55 5409-4518",
        whatsappNumber: "525554094518", // Number for the API (no symbols)
        email: "info@travesianawi.com"
    };

    const handleWhatsAppClick = () => {
        // The message the USER will send TO the agent (localized via dictionary)
        const whatsappUrl = `https://wa.me/${AGENT_DETAILS.whatsappNumber}?text=${encodeURIComponent(t.contact.whatsappMessage)}`;

        window.open(whatsappUrl, '_blank');
    };

    return (
        <div className="page contact-page">
            <SubtleBackground imageIndex={14} />
            <h2>{t.contact.title}</h2>

            <div className="digital-card">
                {/* Avatar / Profile Picture */}
                <div className="card-avatar">
                    <img
                        src="https://ui-avatars.com/api/?name=Natalia+Garciaz&background=1497A3&color=fff&size=128"
                        alt={t.contact.altAvatar}
                    />
                </div>

                <div className="card-content">
                    <h3 className="agent-name">{AGENT_DETAILS.name}</h3>
                    <p className="agent-role">{t.contact.role}</p>

                    <div className="contact-details">
                        <div className="detail-row">
                            <span className="icon">📞</span>
                            <a href={`tel:${AGENT_DETAILS.whatsappNumber}`}>{AGENT_DETAILS.displayPhone}</a>
                        </div>
                        <div className="detail-row">
                            <span className="icon">✉️</span>
                            <a href={`mailto:${AGENT_DETAILS.email}`}>{AGENT_DETAILS.email}</a>
                        </div>
                    </div>

                    <button
                        onClick={handleWhatsAppClick}
                        className="btn-whatsapp-card"
                    >
                        <span className="btn-icon">💬</span> {t.contact.whatsapp}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Contact;
